import {THEME_COLOR, GRAY_SCALE, BODY_BACKGROUND, BORDER} from 'constants/ThemeConstant';

export function rgba(hex, opacity = 1) {
    if (hex === undefined || hex === "undefined" || hex === "null") {
        hex = "#ffffff"
    }

    if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        throw new Error('Invalid Hex');
    }

    const decimal = parseInt(hex.substring(1), 16);

    const r = (decimal >> 16) & 255;
    const g = (decimal >> 8) & 255;
    const b = decimal & 255;

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export const baseTheme = {
    colorPrimary: THEME_COLOR.PRIMARY,
    colorSecondary: THEME_COLOR.SECONDARY,
    colorInfo: THEME_COLOR.PRIMARY,
    colorText: GRAY_SCALE.GRAY,
    colorSuccess: THEME_COLOR.GREEN,
    colorWarning: THEME_COLOR.GOLD,
    colorError: THEME_COLOR.RED,
    colorBorder: BORDER.BASE_COLOR,
    bodyBg: BODY_BACKGROUND,
    borderRadius: 5,
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 36,
    fontFamily: `Roboto,sans-serif`,
    fontSizeHeading2: 22,
    fontSizeHeading4: 17,
};

const getBaseComponentThemeConfig = ({
                                         Button = {},
                                         Menu = {},
                                         Card = {},
                                         Table = {},
                                         Select = {},
                                         DatePicker = {},
                                         Layout = {},
                                         Input = {},
                                         Dropdown = {},
                                         Calendar = {},
                                     } = {}) => {
    return {
        Button: {
            ...Button,
        },
        Dropdown: {
            controlPaddingHorizontal: 20,
            controlHeight: 37,
            borderRadiusLG: 10,
            paddingXXS: '4px 0px',
            ...Dropdown,
        },
        Calendar: {
            ...Calendar,
        },
        Checkbox: {
            lineWidth: 2,
            borderRadiusSM: 4,
        },
        Card: {
            colorTextHeading: GRAY_SCALE.GRAY_DARK,
            paddingLG: 20,
            ...Card,
        },
        Layout: {
            bodyBg: BODY_BACKGROUND,
            headerBg: GRAY_SCALE.WHITE,
            ...Layout,
        },
        Breadcrumb: {
            colorTextDescription: GRAY_SCALE.GRAY_LIGHT,
            colorText: baseTheme.colorPrimary,
            colorBgTextHover: 'transparent',
        },
        Menu: {
            itemBg: 'transparent',
            colorActiveBarHeight: 0,
            activeBarWidth: 3,
            horizontalItemSelectedColor: baseTheme.colorPrimary,
            itemHoverColor: baseTheme.colorPrimary,
            itemSelectedColor: baseTheme.colorPrimary,
            itemSelectedBg: baseTheme.colorPrimary,
            itemHoverBg: 'transparent',
            radiusItem: 0,
            subMenuItemBg: 'transparent',
            itemMarginInline: 0,
            controlHeightLG: 40,
            controlHeightSM: 22,
            ...Menu,
        },
        Input: {
            ...Input,
        },
        Pagination: {
            paginationItemSize: 30,
            borderRadius: '50%',
            colorBgContainer: baseTheme.colorPrimary,
            colorPrimary: GRAY_SCALE.WHITE,
            colorPrimaryHover: GRAY_SCALE.WHITE,
        },
        Steps: {
            wireframe: true,
            controlHeight: 32,
            waitIconColor: GRAY_SCALE.GRAY_LIGHT,
        },
        DatePicker: {
            controlHeight: 40,
            controlHeightSM: 26,
            borderRadiusSM: 6,
            lineWidthBold: 0,
            ...DatePicker,
        },
        Radio: {
            fontSizeLG: 18,
        },
        Slider: {
            colorPrimaryBorder: rgba(baseTheme.colorPrimary, 0.8),
            colorPrimaryBorderHover: baseTheme.colorPrimary,
        },
        Select: {
            paddingXXS: '4px 0px',
            controlHeight: 40,
            controlHeightSM: 30,
            controlItemBgActive: rgba(baseTheme.colorPrimary, 0.1),
            ...Select,
        },
        TreeSelect: {
            controlHeightSM: 24,
        },
        Tooltip: {
            colorBgDefault: rgba(GRAY_SCALE.DARK, 0.75),
            controlHeight: 32,
        },
        Timeline: {
            lineType: 'dashed',
        },
        Tag: {
            lineHeight: 2.1,
        },
        Table: {
            colorText: GRAY_SCALE.GRAY,
            tableHeaderBg: 'transparent',
            ...Table,
        },
    };
};

export const lightTheme = {
    token: {
        ...baseTheme,
        colorTextBase: GRAY_SCALE.GRAY,
    },
    components: getBaseComponentThemeConfig(),
};